
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { loadRoute, toggleBookmark, clearDraftRoute, addDraftRouteMapPoints, setReCentreOnMapLoad, setEditRoute, shareRoute, deleteRoute, react, unReact } from "../../redux/actions/routeActions";
import { loadUserGroups } from "../../redux/actions/groupActions";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import { createEvent } from "../../redux/actions/eventActions";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import Reaction from "../common/Reaction"
import Spinner from "../common/Spinner"
import SelectInput from "../common/formfields/SelectInput"
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'leaflet/dist/leaflet.css';
import "./RouteViewerPage.css";
import { standardisePoint } from "../../api/routeUtilitiesApi";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import moment from "moment";
import $ from 'jquery';
import NavMenu from '../common/NavMenu'; 
import PostControl from "../postComments/PostControl";
import EventForm from "../events/EventForm";
import RouteViewerOsmControl from "./RouteViewerOsmControl";
import RouteViewerGoogleControl from "./RouteViewerGoogleControl";
import MapSwitchControl from "./MapSwitchControl";
import RouteViewerBingControl from "./RouteViewerBingControl";
import ExternalAdvertControl from "../common/ExternalAdvertControl";
import { checkConnectionStatus, sendToDevice } from "../../api/garminApi";
import { Helmet } from 'react-helmet';

function RouteViewerPage({
    route,
    routeId,
    loadRoute,
    loadUserGroups,
    toggleBookmark,
    shareRoute,
    clearDraftRoute,
    addDraftRouteMapPoints,
    setReCentreOnMapLoad,
    setEditRoute,
    deleteRoute,
    react,
    unReact,
    setupNavigation,
    createEvent,
    actions,
    user,
    groups,
    history,
    loading,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [shareProcessing, setShareProcessing] = useState(false);
    const [routeDetails, setRouteDetails] = useState({});
    const [totalDistance, setTotalDistance] = useState(0);
    const [totalElevation, setTotalElevation] = useState(0);
    const [errors, setErrors] = useState({});
    const [sharedGroups, setSharedGroups] = useState([]);
    const [shareDetails, setShareDetails] = useState({});
    const [visiblePoint, setVisiblePoint] = useState(null);
    const [mapState, setMapState] = useState({ mapType: { type: "OSM", variant: "OSM" }, center: {lat: 0, lng: 0}, zoom: 0} )
    const [eventDetails, setEventDetails] = useState({ name: "", location: "", description: "", routeId: null, startDate: new Date(), finishDate: null, organiser: {}, participants: [] });
    const [garminConnected, setGarminConnected] = useState(false);
    const [processingGarmin, setProcessingGarmin] = useState(false);

    var navigationItems =
    {
        sections: [{
            name: 'Options',
            showTitle: true,
            items: [
                {
                    func: onInstigateSendToGarmin,
                    text: 'Send to Garmin',
                    icon: 'fas fa-mobile-android-alt',
                    external: true
                },
                {
                    path: `${apiConfig.API_URL}routes/download/${routeId}`,
                    text: 'Download GPX',
                    icon: 'fas fa-download',
                    external: true
                },
                {
                    func: onInstigateCopyRoute,
                    text: 'Copy Route',
                    icon: 'fas fa-copy'
                }
            ]
        }]
    };

    var adminSection = {
        name: 'Administration',
        showTitle: true,
        items: [
            {
                path: '/routes/edit/' + routeId,
                text: 'Edit Details',
                icon: 'fas fa-edit'
            },
            {
                func: onInstigateEditRoute,
                text: 'Edit Route',
                icon: 'fas fa-map-marked-alt'
            },
            {
                func: onConfirmDeleteRoute,
                text: 'Delete Route',
                icon: 'fas fa-trash-alt'
            }
        ]
    }

    const distanceUnit = user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km';
    const elevationUnit = user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm';
    const chartRef = useRef(null);

    const options = {
        chart: {
            type: 'areaspline',
            color: '#14a4ff',
            fillOpacity: 0.5,
            height: 150,

        },
        plotOptions: {
            areaspline: {
                point: {
                    events: {
                        mouseOver: function (e) {
                            //e.target.selected = true; 

                            route.points.map((point, id) => {
                                if (point.distanceAtPoint == e.target.x && point.elevationAtPoint == e.target.y) {
                                    setVisiblePoint({ marker: point.distanceMarker, state: "show" });
                                    return false;
                                }
                            });
                        },
                        mouseOut: function (e) {
                            //e.target.selected = false; 

                            route.points.map((point, id) => {
                                if (point.distanceAtPoint == e.target.x && point.elevationAtPoint == e.target.y) {
                                    setVisiblePoint(prevVisiblePoint => ({
                                        ...prevVisiblePoint,
                                        marker: point.distanceMarker,
                                        state: "hide"
                                    }));
                                    return false;
                                }
                            });
                        }
                    }
                }
            },
            series: {
                allowPointSelect: true,
                marker: {
                    states: {
                        select: {
                            fillColor: '#76b7e3',
                            lineColor: 'white',
                            lineWidth: 1.5,
                            radius: 3
                        }
                    }
                }
            }
        },
        xAxis: {
            title: {
                text: user.preferredMeasurementUnits == 'Statute' ? 'Distance(mi)' : 'Distance(km)'//,
            }
        },
        yAxis: {
            endOnTick: false,
            maxPadding: 0.2,
            title: {
                text: user.preferredMeasurementUnits == 'Statute' ? 'Elevation(ft)' : 'Elevation(m)'//,
            }
        },
        tooltip: {
            enabled: true,
            headerFormat: '',
            pointFormat: `<br/>Distance: <b>{point.x}</b> ${distanceUnit}<br/>Elevation: <b>{point.y}</b> ${elevationUnit}`
        },
        title: {
            text: undefined
        },

        series: getElevationChartSeries(),
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
    };

    var apiCallsInProgress = 0;

    useEffect(() => {

        if (!route || route.routeId != routeId) {
            apiCallsInProgress++
            loadRoute(routeId)
                .then((r) => {
                    document.title = `${r.name} | JustGoRide`
                    setRouteDetails(r);
                    setRouteVitals(r);
                    apiCallsInProgress--;
                    if (apiCallsInProgress == 0) setProcessing(false);

                })
                .catch(error => {
                    if (error.message === "401" || error.message === "404") {
                        history.push("/resourceunavailable");
                        return;
                    }
                    console.error("Loading routes failed: " + error);
                    history.push("/oops");
                });
        }
        else {
            document.title = `${route.name} | JustGoRide`
            setRouteDetails(route);
            setRouteVitals(route);
            setProcessing(false)
        }


        if (user.id && !groups.userGroupsInitialised) {
            setProcessing(true);
            apiCallsInProgress++
            loadUserGroups()
                .then(() => {
                    apiCallsInProgress--;
                    if (apiCallsInProgress == 0) setProcessing(false);
                })
        }

    }, [routeId]);

    useEffect(() => {
        if (groups.userGroupsInitialised && route.associatedGroups) {
            var groupsForSharing = []
            groups.userGroups.map(ug => {
                var routeAlreadyShared = false;
                route.associatedGroups.map(ag => {
                    if (ag.groupId == ug.id) {
                        routeAlreadyShared = true;
                    }
                })
                if (!routeAlreadyShared && !ug.archived) groupsForSharing.push({ value: ug.id, text: ug.name });
            });
            setSharedGroups(groupsForSharing);
            if (groupsForSharing.length > 0 && !route.private) {
                navigationItems.sections[0].items.push(
                    {
                        func: onOpenShareRouteDialog,
                        text: 'Share With Group',
                        icon: 'fas fa-share-square'
                    })
            }
            if (!route.private) {
                navigationItems.sections[0].items.push(
                    {
                        func: onOpenEventModal,
                        text: 'Create Event',
                        icon: 'far fa-calendar-alt'
                    })
            }
            buildNavigation(route);
        }

    }, [groups, route])

    function buildNavigation(route) {
        if (route.associatedGroups.length > 0) {
            var avatarLinks = {
                name: 'Associated Groups',
                links: []
            };
            route.associatedGroups.map(g => {
                var link = { label: g.groupName, path: `/groups/${g.groupId}`, avatarClass: 'avatar-link-group', icon: 'fas fa-users' };
                if (g.avatarAvailable) {
                    link.avatar = `${apiConfig.API_URL}groups/avatar/${g.groupId}.png?v=${g.avatarVersion}`
                }
                avatarLinks.links.push(link);
                navigationItems.avatarLinks = avatarLinks;
            })
        }
        if (route.ownerId.toUpperCase() == user.id.toUpperCase()) {
            navigationItems.sections.push(adminSection);
        }
        setupNavigation(navigationItems);
    }


    function setRouteVitals(routeData) {
        setTotalDistance(user && user.preferredMeasurementUnits == 'Statute'
            ? (routeData.totalDistanceKm * 0.621371192).toFixed(2)
            : routeData.totalDistanceKm.toFixed(2));

        setTotalElevation(user && user.preferredMeasurementUnits == 'Statute'
            ? (routeData.totalElevation * 3.2808399).toFixed(0)
            : routeData.totalElevation.toFixed(0));
    }

    function getDistanceBetweenPoints(p1, p2) {
        var earthRadius = 6371;
        var dLat = getRadians(p2.latitude - p1.latitude);
        var dLon = getRadians(p2.longitude - p1.longitude);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(getRadians(p1.latitude)) * Math.cos(getRadians(p2.latitude)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return (earthRadius * c) * 1000;
    };


    function getRadians(x) {
        var pi = 3.14159265358979;
        return x * pi / 180;
    };


    function getElevationChartSeries() {
        var elevationSeries = [];
        var lastPoint = {};
        var totalDistanceM = 0;

        if (route.routeId) {
            route.points.map((point, id) => {
                if (id === 0) {
                    point.distanceAtPoint = 0;
                }
                else {
                    var distanceBetweenPoints = getDistanceBetweenPoints(lastPoint, point);
                    totalDistanceM += distanceBetweenPoints;
                    //set units
                    var distanceKm = totalDistanceM / 1000;
                    if (user.preferredMeasurementUnits == 'Statute') {
                        distanceKm = distanceKm * 0.621371192;
                    }
                    //round up and assign
                    point.distanceAtPoint = Math.round(distanceKm * Math.pow(10, 2)) / Math.pow(10, 2);
                }
                //set elevation to 2 decimal places
                var elevationAtPoint = point.elevation
                if (user.preferredMeasurementUnits == 'Statute') {
                    elevationAtPoint = elevationAtPoint * 3.2808399;
                }
                //round up and assign
                point.elevationAtPoint = Math.round(elevationAtPoint * Math.pow(10, 2)) / Math.pow(10, 2);

                elevationSeries.push([point.distanceAtPoint, point.elevationAtPoint])
                lastPoint = point;
            });
        }
        return [{
            id: "elevationdata",
            data: elevationSeries,
            turboThreshold: 4000
        }];
    }

    function showPointDetails(point) {

        var distance = point.distanceAtPoint;
        var highchart = chartRef.current;

        var series = highchart.chart.get('elevationdata');
        series.data.map(data => {
            if (data.x == distance) {
                data.select(true);
            }
        });
    }

    function hidePointDetails() {
        var highchart = chartRef.current;
        var series = highchart.chart.get('elevationdata');
        series.data.map(data => {
            data.select(false);
        });
    }

    function onToggleBookmark() {

        var toggle = !routeDetails.bookmarked;

        setRouteDetails(prevRouteDetails => ({
            ...prevRouteDetails,
            bookmarked: toggle
        }));

        handleToggleBookmark(routeDetails);
    }

    function handleToggleBookmark(r) {
        toggleBookmark(r);
    }

    function onInstigateSendToGarmin(e) {
        e.preventDefault();
        $("#cmdGarmin").click();
    }

    function onSendToGarmin(e) {
        e.preventDefault();
        setProcessingGarmin(true);
        $("#sendToDeviceModal").modal("show");
        checkConnectionStatus()
            .then(connected => {
                setGarminConnected(connected)
                if (connected) {
                    sendToDevice(routeDetails.routeId)
                        .then(() => {
                            setRouteDetails(prevRouteDetails => ({
                                ...prevRouteDetails,
                                bookmarked: true
                            }));
                            setProcessingGarmin(false);
                        })
                        .catch(error => {
                            errors.garmin = "Failed to transfer to Garmin: " + error;
                            setErrors(errors);
                            setProcessingGarmin(false);
                        })
                }
                else {
                    setProcessingGarmin(false);
                }
            })
            .catch(error => {
                errors.garmin = "Connection status check failed: " + error;
                setErrors(errors);
                setProcessingGarmin(false);
            })
    }

    function onInstigateCopyRoute(e) {
        e.preventDefault();
        $("#cmdCopy").click();
    }

    function onCopyRoute(e) {
        e.preventDefault();
        if (routeDetails.routeId) {
            var draftRoute = [];
            routeDetails.points.map((point) => {
                let p = standardisePoint({ lat: point.latitude, lng: point.longitude });
                p.ele = point.elevation;
                draftRoute.push(p)
            });
            clearDraftRoute();
            addDraftRouteMapPoints(draftRoute);
            setReCentreOnMapLoad(true);
            history.push("/routes/create");
        }
    }

    function onInstigateEditRoute(e) {
        e.preventDefault();
        $("#cmdEdit").click();
    }

    function onEditRoute(e) {
        e.preventDefault();
        if (routeDetails.routeId) {
            var draftRoute = [];
            routeDetails.points.map((point) => {
                let p = standardisePoint({ lat: point.latitude, lng: point.longitude });
                p.ele = point.elevation;
                draftRoute.push(p)
            });
            clearDraftRoute();
            addDraftRouteMapPoints(draftRoute);
            setEditRoute({ id: routeId, name: route.name })
            setReCentreOnMapLoad(true);
            history.push("/routes/create");
        }
    }

    function onConfirmDeleteRoute(e) {
        e.preventDefault();
        $('#deleteRoute').modal('show');
    }

    function onCancelDeleteRoute(e) {
        e.preventDefault();
        $('#deleteRoute').modal('hide');
    }

    function onDeleteRoute(e) {
        e.preventDefault();
        $('#deleteRoute').modal('hide');
        setProcessing(true);
        deleteRoute(route)
            .then(() => {
                toast.success(`Route Deleted`);
                history.push("/user/profile");
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete route: ${error.message}`);
            });
    }

    function onOpenShareRouteDialog(e) {
        e.preventDefault();
        $('#shareRoute').modal('show');
    }

    function onShareRoute(e) {
        e.preventDefault();
        setShareProcessing(true);

        var groupToShare;
        groups.userGroups.map(g => {
            if (g.id == parseInt(shareDetails.group)) {
                groupToShare = g;
            }
        })

        shareRoute(route, groupToShare, user)
            .then(() => {
                toast.success("Route Shared!");
                $('#shareRoute').modal('hide')
                setShareProcessing(false);
            })

    }

    function onCancelShare(e) {
        e.preventDefault();
        $('#shareRoute').modal('hide')
    }

    function onShareChange(e) {
        var { name, value } = e.target;
        setShareDetails(prevShareDetails => ({
            ...prevShareDetails,
            [name]: value
        }));
    }

    function handleOnReact(reaction) {
        react({ reaction: reaction, userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable, itemId: route.routeId });
    }

    function handleOnUnReact() {
        unReact({ userId: user.id, itemId: route.routeId })
    }

    function openCommentsModal(e) {
        e.preventDefault();
        $('#commentsModal').modal('show')
    }

    function handleCommentCountChanged(count) {
        var post = route.commentPost;
        post.commentCount = count
        setRouteDetails(prevRouteDetails => ({
            ...prevRouteDetails,
            commentPost: post
        }));
    }

    function handleMapTypeChanged(type) {
        setVisiblePoint(null);
        setMapState(prevMapState => ({
            ...prevMapState,
            mapType: type
        }));
    }

    function handleZoomChanged(zoom) {
        setMapState(prevMapState => ({
            ...prevMapState,
            zoom: zoom
        }));
    }
    function handleCenterChanged(latLng) {
        setMapState(prevMapState => ({
            ...prevMapState,
            center: latLng
        }));
    }

    function getRouteCategoryBadge(category) {
        switch (category) {
            case "Road":
                return "/resources/images/road75.png";
            case "OffRoad":
                return "/resources/images/mtb75.png";
            case "Gravel":
                return "/resources/images/gravel75.png";
            default:
                return "/resources/images/road75.png"
        }
    }

    function getEventGroups() {
        var groupChoice = [];
        if (groups.userGroups) {
            groups.userGroups.map(group => {
                if (!group.archived) {
                    groupChoice.push({ value: group.id, text: group.name })
                }
            })
        }
        return groupChoice;
    }

    function onOpenEventModal(e) {
        e.preventDefault();
        $('#newEvent').modal('show')
    }

    function handleChangeEvent(e) {
        var { name, value } = e.target;

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: null
        }))

        if (name == "groupId") {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                group: { id: parseInt(value), name: getGroupName(value) },
                groupId: parseInt(value)
            }));
            return;
        }

        if (name == "startDate" && eventDetails.finishDate == null) {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                finishDate: moment(value).add(2, 'h').toDate(),
                startDate: value
            }));
            return;
        }

        setEventDetails(prevEventDetails => ({
            ...prevEventDetails,
            [name]: value
        }));
    }

    function getGroupName(id) {
        var name;
        groups.userGroups.map(group => {
            if (group.id == id) name = group.name
        })
        return name;
    }

    function handleSaveEvent(e) {
        e.preventDefault();

        if (!eventFormIsValid()) {
            return;
        }

        eventDetails.route = { id: route.routeId, name: route.name };
        eventDetails.routeId = route.routeId;
        eventDetails.organiser = { userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable }
        eventDetails.participants = [{ userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable, status: 0 }]

        $('#newEvent').modal('hide')
        setProcessing(true);

        createEvent(eventDetails)
            .then((event) => {

                var shareRoute = true;
                if (route.associatedGroups) {
                    route.associatedGroups.map(ag => {
                        if (ag.groupId === event.groupId) {
                            shareRoute = false; 
                        }
                    })
                }

                if (shareRoute) {
                    sharedEventRouteWithGroup(event);
                }
                else {
                    setProcessing(false);
                    toast.success(`Event Created: ${event.name}`);
                    history.push(`/events/${event.id}`);
                }

                
            })
            .catch(error => {
                setProcessing(false);
                $('#newEvent').modal('show')
                setErrors({ onSave: error.message });
            });
    }

    function sharedEventRouteWithGroup(event) {
        var groupToShare;
        groups.userGroups.map(g => {
            if (g.id == event.groupId) {
                groupToShare = g;
            }
        })

        shareRoute(route, groupToShare, user)
            .then(() => {
                setProcessing(false);
                toast.success(`Event Created: ${event.name}`);
                history.push(`/events/${event.id}`)
            })
    }

    function eventFormIsValid() {
        const errors = {};
        var isValid = true;

        if (!eventDetails.name) {
            errors.name = "An event title is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.location) {
            errors.location = "A location is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.groupId) {
            errors.route = "A group is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.description) {
            errors.description = "A description is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!moment(eventDetails.finishDate).isSameOrAfter(eventDetails.startDate)) {
            errors.finishDate = "End date must be after the start date!";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    function handleCancelSaveEvent(e) {
        e.preventDefault();
        $('#newEvent').modal('hide')
    }

    return (
        <React.Fragment>
            {
                processing ?
                    <Spinner />
                    : (
                        <div className="container-fluid h-100">
                            <Helmet>
                                <meta name="title" content={`JustGoRide | ${route.name}`} />
                                <meta name="description" content={route.description} />
                                <meta name="keywords" content={`${route.category} cycling route, ${route.locationInformation ? route.locationInformation.locationString : ""}`} />
                                <meta content={`JustGoRide | ${route.name}`} property="og:title"/>
                                <meta content={`${totalDistance} ${distanceUnit} cycling route. ${route.description}`} property="og:description"/>
                                <meta content="fitness.course" property="og:type"/>
                                <meta content={`https://www.justgoride.co.uk/routes/${route.routeId}`} property="og:url"/>
                            </Helmet>
                            <div className="title-bar col-12">
                                <div className="route-details">
                                    <img className="route-category-image" src={getRouteCategoryBadge(route.category)} alt={route.category} />
                                    <div className="route-name">{route.name}</div>
                                    <div className="route-location">{route.locationInformation ? route.locationInformation.locationString : ""}</div>
                                </div>
                            </div>
                            <nav className="col-md-3 ml-sm-auto col-lg-2 d-none d-md-block bg-light route-sidebar sidebar">
                                <div className="sidebar-sticky">
                                    <div className="">
                                        <ul className="route-vitals">
                                            <li><span className="nav-title">Distance</span> <b>{totalDistance}</b> {distanceUnit}</li>
                                            <li><span className="nav-title">Elevation</span> <b>{totalElevation}</b> {elevationUnit}</li>
                                        </ul>
                                        <hr />
                                        <div className="nav-title">Description</div>
                                        <div className="route-description">
                                            {route.description}
                                        </div>
                                        <hr />
                                    </div>
                                    <NavMenu hideProfileLink={true} />
                                    {!user || !user.id &&
                                        <ExternalAdvertControl mode="route" />
                                    }
                                </div>
                            </nav>
                            <main role="main" className="h-100 col-md-9 ml-sm-auto col-lg-10">

                                <div className="title-bar-footer">
                                    <div className="upload-details">
                                        {user.id && (user.id.toUpperCase() == route.ownerId.toUpperCase()) ?
                                            <UserAvatar className="upload-details-avatar" size="30" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                            :
                                            <UserAvatar className="upload-details-avatar" size="30" name={`${route.ownerFirstName} ${route.ownerSurname}`} src={route.ownerHasAvatar ? `${apiConfig.API_URL}user/avatar/${route.ownerId}.png` : ""} />
                                        }
                                        <span className="upload-details-desc muted">Uploaded by <Link to={`/user/profile/${route.ownerId}`}>{`${route.ownerFirstName} ${route.ownerSurname}`}</Link>{` on ${moment(route.dateUploaded).format("Do MMMM YYYY")}`}</span>
                                    </div>
                                    {user.id &&
                                        <div className="route-header-options">
                                            <Reaction userReactions={route.userReactions} user={user} onReact={handleOnReact} onUnReact={handleOnUnReact} overrideDialog={true} />
                                            <div className="comment-container" onClick={openCommentsModal}>
                                                <span className="far fa-comment"></span>
                                                <span className="item-counter">({routeDetails.commentPost.commentCount})</span>
                                            </div>
                                            <div className="bookmark-container">
                                                <span title={route.bookmarked ? "Remove Bookmark" : "Bookmark Route"} onClick={onToggleBookmark} className={route.bookmarked ? "fas fa-star route-bookmark bookmarked" : "far fa-star route-bookmark"}></span>
                                            </div>
                                        </div>
                                    }
                                </div>



                                <div className="map-container">
                                    <MapSwitchControl mapChanged={handleMapTypeChanged} mapType={mapState.mapType.variant} />
                                    {
                                        (() => {
                                            switch (mapState.mapType.type) {
                                                case "OSM":
                                                    return (
                                                        <RouteViewerOsmControl route={route} user={user} state={mapState} visiblePoint={visiblePoint} onZoomChanged={handleZoomChanged} onCenterChanged={handleCenterChanged} onShowPoint={showPointDetails} onHidePoint={hidePointDetails} />
                                                    )
                                                case "GOOGLE":
                                                    return (
                                                        <RouteViewerGoogleControl route={route} user={user} state={mapState} visiblePoint={visiblePoint} onZoomChanged={handleZoomChanged} onCenterChanged={handleCenterChanged} onShowPoint={showPointDetails} onHidePoint={hidePointDetails} />
                                                    )
                                                case "BING":
                                                    return (
                                                        <RouteViewerBingControl route={route} user={user} state={mapState} visiblePoint={visiblePoint} onZoomChanged={handleZoomChanged} onCenterChanged={handleCenterChanged} onShowPoint={showPointDetails} onHidePoint={hidePointDetails} />
                                                    )
                                                default:
                                                    return null;
                                            }
                                        })()
                                    }
                                </div>
                                <div className="elevation-chart col-md-9 ml-sm-auto col-lg-10" >
                                    <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
                                </div>
                                <div className="route-data-status-bar">
                                    <span>Distance: <em>{totalDistance}</em> {distanceUnit}</span>
                                    <span> <em>|</em> Elevation: <em>{totalElevation}</em> {elevationUnit}</span>
                                </div>
                            </main>
                            {user.id &&
                                <React.Fragment>
                                    <div className="modal fade" id={`deleteRoute`} tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title" >Delete Route?</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    Are you sure that you want to delete this Route?
                                            </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-link" onClick={onCancelDeleteRoute}>No</button>
                                                    <button type="button" className="btn btn-info" onClick={onDeleteRoute}>Yes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id={`commentsModal`} tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title" >Comments</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="post-feed route-comment-feed">
                                                    <PostControl post={route.commentPost} active={true} headless={true} expandComments={true} onCommentCountChanged={handleCommentCountChanged} onPostEdited={() => { }} onPostDeleted={() => { }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id={`reactions-${route.userReactions.itemType}-${route.userReactions.itemId}`} tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title" >Reactions</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body reactions-modal-body">
                                                    <div className="row justify-content-center">
                                                        <div className="col-11">
                                                            <ul className="all-reactions">
                                                                {
                                                                    route.userReactions.users.map(user => {
                                                                        return (
                                                                            <li key={user.userId} className="reactor" title={`${user.firstName} ${user.surname}`} >
                                                                                <UserAvatar className="reactor-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.hasAvatar ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""} />
                                                                                <div className={"reaction"}><span className={"fas fa-thumbs-up"}></span></div>
                                                                                <div className="reactor-name">{`${user.firstName} ${user.surname}`}</div>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="shareRoute" tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title">Share with a Group</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <p>Select a group to share this route with...</p>
                                                    {
                                                        shareProcessing ?
                                                            <Spinner /> : (
                                                                <form onSubmit={onShareRoute} className="">
                                                                    {errors.onShareRoute && (
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {errors.onShareRoute}
                                                                        </div>
                                                                    )}
                                                                    <SelectInput
                                                                        name="group"
                                                                        label=""
                                                                        value={shareDetails.group || ""}
                                                                        defaultOption="Select Group"
                                                                        options={sharedGroups}
                                                                        onChange={onShareChange}
                                                                        error={errors.group}
                                                                    />
                                                                    <button type="submit" className="btn btn-info float-right">
                                                                        Share
                                                                    </button>
                                                                    <button className="btn btn-link float-right mr-1" onClick={onCancelShare}>
                                                                        Cancel
                                                                    </button>
                                                                </form>
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="newEvent" tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title">Create an Event around {route.name}</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <EventForm
                                                        event={eventDetails}
                                                        groups={getEventGroups()}
                                                        routes={null}
                                                        onChange={handleChangeEvent}
                                                        onSave={handleSaveEvent}
                                                        onCancel={handleCancelSaveEvent}
                                                        saving={processing}
                                                        errors={errors}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="sendToDeviceModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                                    <h5 className="modal-title">Send to Garmin</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            <div className="modal-body">
                                                {processingGarmin ?
                                                    <Spinner />
                                                    :
                                                    <React.Fragment>
                                                        {errors.garmin ?
                                                            <React.Fragment>
                                                                <div className="alert alert-danger" role="alert">
                                                                    {errors.garmin}
                                                                </div>
                                                                <button className="btn btn-info float-right mt-4" data-dismiss="modal">OK</button>
                                                            </React.Fragment>
                                                        :
                                                        garminConnected ?
                                                            <div className="my-4 text-center">
                                                                <h5>Route Bookmarked and Sent to Garmin Connect!</h5>
                                                                <p>
                                                                    Switch on your Garmin Device, wait a few moments for the route to
                                                                    download and then check the courses directory.
                                                                </p>
                                                                <button className="btn btn-info float-right mt-4" data-dismiss="modal">OK</button>
                                                            </div>
                                                            :
                                                            <div className="my-4 text-center">
                                                                <h5>Connect to Garmin to Enable Device Transfer</h5>
                                                                <p>
                                                                    Click 'Connect' to start the process of authorising a connection
                                                                    with Garmin to enable the transfer of routes to your Garmin Device.
                                                                </p>
                                                                <button className="btn btn-info float-right mt-4" data-dismiss="modal" onClick={() => history.push("/user/settings/garmin")}>Connect</button>
                                                                <button className="btn btn-link float-right mt-4" data-dismiss="modal">Cancel</button>
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                                }
                                <span id="cmdCopy" onClick={onCopyRoute} style={{ display: "none" }}></span>
                                <span id="cmdEdit" onClick={onEditRoute} style={{ display: "none" }}></span>
                                <span id="cmdGarmin" onClick={onSendToGarmin} style={{ display: "none" }}></span>
                            
                        </div>
                       
                    )
            }
        </React.Fragment>


    );

}

RouteViewerPage.propTypes =
{
    route: PropTypes.object.isRequired,
    routeId: PropTypes.string.isRequired,
    loadRoute: PropTypes.func.isRequired,
    loadUserGroups: PropTypes.func.isRequired,
    toggleBookmark: PropTypes.func.isRequired,
    shareRoute: PropTypes.func.isRequired,
    clearDraftRoute: PropTypes.func.isRequired,
    addDraftRouteMapPoints: PropTypes.func.isRequired,
    setReCentreOnMapLoad: PropTypes.func.isRequired,
    setEditRoute: PropTypes.func.isRequired,
    react: PropTypes.func.isRequired,
    unReact: PropTypes.func.isRequired,
    setupNavigation: PropTypes.func.isRequired,
    createEvent: PropTypes.func.isRequired,
    actions: PropTypes.object,
    user: PropTypes.object.isRequired,
    groups: PropTypes.object.isRequired
}


function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        routeId: id,
        route: state.route,
        user: state.user,
        groups: state.groups,
        loading: state.apiCallsInProgress > 0
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadRoute,
    loadUserGroups,
    toggleBookmark,
    shareRoute,
    clearDraftRoute,
    addDraftRouteMapPoints,
    setEditRoute,
    deleteRoute,
    react,
    unReact,
    createEvent,
    setReCentreOnMapLoad
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteViewerPage)




// WEBPACK FOOTER //
// ./src/components/routes/RouteViewerPage.js